<template>
  <ul class="pagination" v-if="shouldPaginate">
    <li v-show="previous">
      <a href="#" aria-label="Anterior" rel="prev" @click.prevent="page--">
        <span aria-hidden="true">&laquo; Anterior</span>
      </a>
    </li>
    <li v-show="next">
      <a href="#" aria-label="Próxima" rel="next" @click.prevent="page++">
        <span aria-hidden="true">Próxima &raquo;</span>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  props: ["dataSet"],
  data() {
    return {
      page: 1,
      previous: false,
      next: false
    };
  },
  watch: {
    dataSet() {
      this.page = this.dataSet.current;
      this.previous = this.dataSet.previous;
      this.next = this.dataSet.next;
    },
    page() {
      this.$emit("changed", this.page);
    }
  },
  computed: {
    shouldPaginate() {
      return !!this.previous || !!this.next;
    }
  }
};
</script>
